<template>
<div class="enWarehouse">
  <!-- 等待扫码页面 -->
  <div class="wait_view">
    <h1 class="title">请扫描入库单号进行投递</h1>
    <div class="img_wrap">
      <img src="/static/images/scan.svg">
    </div>
  </div>
  <!-- 扫码单号Dialog -->
  <el-dialog :visible.sync="dialogVisible" :close-on-click-modal="closeOnClickModal">
    <span>入库单号：{{wareHouse.trackNum}}正在投递，已为你打开{{wareHouse.boxNo}}号箱格，请放入物品后随手关门</span>
  </el-dialog>
  <!-- 底部按钮 -->
  <div class="btn_wrap">
    <div class="bin_btn btn" @click.stop="toReturn">返回</div>
    <div class="exit_btn btn"  @click.stop="toExit">退出登录</div>
  </div>
  <!-- 引入mqtt组件，由mqtt告诉我扫描的单号和箱格门状态 -->
  <!-- <mqttws :topic="topic" :msg="msg" :isConnect="isConnect" ref="mqttws" @getMessage="getMessage"></mqttws> -->
</div>
  
  
</template>

<script>
var _this,Timer
import "../../../../static/CEsite/css/common.less"
import mqttws from "../../../assets/mqttws"
import * as config from '../../../../static/js/config'
export default {
  name: 'enWarehouseScan',
  components: {
    mqttws
  },
  data() {
    return {
      actionType: '',
      dialogVisible: false,
      closeOnClickModal: false,
      // mqtt返回数据
      wareHouse: {
        boxNo: '11', // 空闲箱格号（由后台或者硬件告知）
        trackNum: '10087', // 单号（由后台或者硬件告知）
      },
      // 连接mqtt
      topic: '/' + config.clientPort + '/report/' + config.serverPort + '/environment/protocol',
      msg: '',
      isConnect: true, // 是否默认订阅
    }
  },
  created() { // 
    this.actionType = this.$route.query.actionType;
    console.warn('扫码页actionType：',this.actionType);
  },
  mounted() {
    _this = this;
    Timer = setTimeout(() => {
      _this.dialogVisible = true;
    }, 1000);
    Timer = setTimeout(() => {
      let {trackNum, boxNo} = _this.wareHouse; // 携带箱格数据跳转下一页
      _this.dialogVisible = false;
      _this.$router.push({
        path: '/eSite/enWarehouse/enWarehouseFinal',
        query: {actionType: _this.actionType, wareHouse:{trackNum, boxNo}}
      })
    }, 3000);
  },
  destroyed() {
    clearTimeout(Timer);
    // clearTimeout(endTimer);
  },
  methods: {
    // mqtt通讯的返回数据: 扫码的入库单号->几号箱格打开；通报该箱格关闭后，即认为是存件完成，(携带单号，箱格号)跳到下一页
    getMessage(res){
      console.log('mqtt返回的数据：', res);
      if(res){

      }
    },
    // 返回上一页
    toReturn() {
      _this.$router.go(-1);
    },
    // 退出登录,需要清除token
    toExit() {
      _this.$router.push({
        path: '/',
      })
    },
  },
}
</script>

<style lang="less">
.enWarehouse{
.wait_view {
  position: absolute;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  .title {
    font-size: 0.8rem;
    margin-bottom: 0.2rem;
  }
  .img_wrap {
    width: 50%;
    height: 4rem;
    text-align: center;
    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
}
.el-dialog {
    top: 50%;
    margin-top: 0 !important;
    transform: translateY(-50%);
    width: 53% !important;
    .el-dialog__header {
      display: none;
    }
    .el-dialog__body {
      font-size: 0.28rem;
    }
}
}
</style>





// WEBPACK FOOTER //
// src/components/CEsite/EN-warehouse/enWarehouseScan.vue